import { render, staticRenderFns } from "./BoostSales.vue?vue&type=template&id=ecff6cbc&scoped=true&"
import script from "./BoostSales.vue?vue&type=script&lang=js&"
export * from "./BoostSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecff6cbc",
  null
  
)

export default component.exports